var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    { attrs: { page: "/myschedule", pageTitle: "Booking" } },
    [
      _c(
        "v-container",
        { staticClass: "h-full" },
        [
          _c(
            "v-row",
            { staticClass: "h-full" },
            [
              _c(
                "v-col",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "soli-grey soli-round",
                      attrs: { flat: "" },
                    },
                    [
                      _c("v-card-title", { staticClass: "pb-0" }, [
                        _vm._v("Service"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-chip-group",
                        {
                          attrs: { "center-active": "" },
                          model: {
                            value: _vm.form.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "type", $$v)
                            },
                            expression: "form.type",
                          },
                        },
                        _vm._l(_vm.bookingTypes, function (chip, idx) {
                          return _c(
                            "v-chip",
                            {
                              key: idx,
                              class: {
                                "ml-3": idx == 0,
                                "mr-3": _vm.bookingTypes.length - 1 == idx,
                              },
                              attrs: {
                                outlined: "",
                                "active-class": "primary--text",
                              },
                            },
                            [_vm._v(_vm._s(chip))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card",
                    {
                      staticClass: "soli-grey soli-round",
                      attrs: { flat: "" },
                    },
                    [
                      _c("v-card-title", { staticClass: "pb-0" }, [
                        _vm._v("Who"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-chip-group",
                        {
                          attrs: { "center-active": "" },
                          model: {
                            value: _vm.form.who,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "who", $$v)
                            },
                            expression: "form.who",
                          },
                        },
                        _vm._l(_vm.relationships, function (chip, idx) {
                          return _c(
                            "v-chip",
                            {
                              key: idx,
                              class: {
                                "ml-3": idx == 0,
                                "mr-3": _vm.relationships.length - 1 == idx,
                              },
                              attrs: {
                                outlined: "",
                                "active-class": "primary--text",
                              },
                            },
                            [_vm._v(_vm._s(chip.name))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card",
                    {
                      staticClass: "soli-grey soli-round",
                      attrs: { flat: "" },
                    },
                    [
                      _c("v-card-title", [_vm._v("When")]),
                      _vm._v(" "),
                      _c("BookingAvailability", {
                        attrs: {
                          errors: _vm.errors,
                          instrument: { name: "Guitar", id: 1 },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }